exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bulma .tabs-container .tabs-details .test-edit-settings-item .label[data-v-5e24534b] {\n  font-size: 1.2rem;\n  font-weight: 600;\n  line-height: 19px;\n  text-align: left;\n  min-width: 137px;\n  align-self: center;\n}", ""]);

// exports
